export enum FileStatus {
  PROCESSING = 'PROCESSING',
  PARSING = 'PARSING',
  PROCESSED = 'PROCESSED',
}

export enum FileListVariant {
  COMPACT_LIST = 'COMPACT_LIST',
  FIXED_HEIGHT_SCROLL = 'FIXED_HEIGHT_SCROLL',
  TABLE_STYLE = 'TABLE_STYLE',
  HORIZONTAL_CARDS = 'HORIZONTAL_CARDS',
}

export interface UploadedFile {
  id: string;
  name: string;
  size: number;
  status: FileStatus;
  uploadedAt: Date;
}

/**
 * Maps backend file status string to FileStatus enum
 * Backend returns status as a string: 'parsing', 'ready', or 'failed'
 */
export const mapFileStatus = (status: unknown): FileStatus => {
  // Handle string status directly
  if (typeof status === 'string') {
    const statusLower = status.toLowerCase();
    switch (statusLower) {
      case 'parsing':
        return FileStatus.PARSING;
      case 'ready':
        return FileStatus.PROCESSED;
      case 'failed':
        // Map failed to PROCESSING so user can see something went wrong
        // Alternatively, we could add a FAILED status to the enum
        return FileStatus.PROCESSING;
      default:
        return FileStatus.PROCESSING;
    }
  }

  // Fallback: if status is an object, try to extract string value
  if (status && typeof status === 'object') {
    const statusObj = status as Record<string, unknown>;
    const statusValue =
      (statusObj.status as string) || (statusObj.state as string) || (statusObj.value as string);

    if (typeof statusValue === 'string') {
      return mapFileStatus(statusValue);
    }
  }

  // Default to PROCESSING if status is unknown
  return FileStatus.PROCESSING;
};
